import React from "react";
import { RiHeart2Fill} from "react-icons/ri";
import { FaUmbrellaBeach, FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => {
    return (
        <footer className="w-full border-t border-white/50 bg-slate-950 text-white">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <FaUmbrellaBeach className="text-2xl text-[#f7c45f]" />
                            <h3 className="text-2xl font-bold">lava.rent</h3>
                        </div>
                        <p className="text-white/65">
                            Premium vacation rentals in beautiful Lavallette, New Jersey.
                        </p>
                    </div>
                    
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
                        <div className="space-y-2 text-white/65">
                            <a href="tel:412-337-9034" className="flex items-center gap-2 hover:text-white transition">
                                <FaPhone className="text-sm text-[#f7c45f]" />
                                <span>412-337-9034</span>
                            </a>
                            <p className="flex items-center gap-2">
                                <MdEmail className="text-[#f7c45f]" />
                                <span>Sunset Bay Properties, LLC</span>
                            </p>
                        </div>
                    </div>
                    
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Location</h4>
                        <p className="text-white/65">
                            Lavallette, NJ<br />
                            The Jersey Shore's Hidden Gem
                        </p>
                    </div>
                </div>
                
                <div className="border-t border-white/10 pt-6 text-center">
                    <div className="flex justify-center items-center gap-2 text-sm text-white/65">
                        <p>Made with</p>
                        <RiHeart2Fill className="text-red-400 text-lg animate-pulse"/>
                        <p>by Sunset Bay Properties, LLC</p>
                    </div>
                    <p className="text-white/45 text-xs mt-2">
                        © {new Date().getFullYear()} All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
